module.exports = "\r\n// Common module loading\r\nvar Link = require('react-tiles').Link;\r\n\r\n// ... or using ES5 module imports\r\nimport {Link} from 'react-tiles';\r\n\r\n// ... then in your component's render method\r\n<Link to=\"/myRoute\">Go to my route</Link>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/linkAPI.html
 ** module id = 280
 ** module chunks = 0
 **/